import { Badges, LI, UL } from '../../../AbstractElements'
import { LtrDataType } from '../../../Types/ThemeCustomizerTypes'
import { RTLBadges } from '../../../Utils/Constants'
import CommonUL from './CommonUL'

const RTL = ({ handleLayout, layout_type }: LtrDataType) => {
  return (
    <LI className={`${layout_type === "rtl" ? "active" : ""}`} onClick={() => handleLayout("rtl")}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body">
        <UL>
          <LI className="bg-light body me-1">
            <Badges color="primary">{RTLBadges}</Badges>
          </LI>
          <LI className="bg-light sidebar"></LI>
        </UL>
      </div>
    </LI>
  )
}

export default RTL